import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "nuart_auth_token";

export const setAuthToken = (token) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
};
export const getAuthToken = () => {
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
};

const api = axios.create({
  baseURL: API,
  withCredentials: true,  // mantiene cookies para sesiones legacy
});

api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;

export const fileUrl = (storagePath, size = "md") => {
  if (!storagePath) return "";
  if (storagePath.startsWith("http")) {
    // External URLs (Unsplash, etc): rewrite width so we don't ship a
    // 2-4 MB image when we only display a 400-900px thumbnail.
    const widths = { sm: 360, md: 700, lg: 1400, orig: 2400 };
    const qualities = { sm: 55, md: 65, lg: 76, orig: 82 };
    const targetW = widths[size] || widths.md;
    try {
      const url = new URL(storagePath);
      if (url.hostname.endsWith("unsplash.com")) {
        const oldW = parseInt(url.searchParams.get("w") || "0", 10);
        const oldH = parseInt(url.searchParams.get("h") || "0", 10);
        // Preserve aspect when both w & h are present (panoramic crops, etc.)
        if (oldW && oldH) {
          const newH = Math.max(1, Math.round((oldH * targetW) / oldW));
          url.searchParams.set("w", String(targetW));
          url.searchParams.set("h", String(newH));
        } else {
          url.searchParams.set("w", String(targetW));
        }
        url.searchParams.set("q", String(qualities[size] || qualities.md));
        url.searchParams.set("auto", "format");
        url.searchParams.set("fm", "webp");
        return url.toString();
      }
    } catch (_e) { /* not a URL we can rewrite */ }
    return storagePath;
  }
  // size: "sm" (~500px, cards), "md" (~900px, featured/mobile),
  // "lg" (~1600px, detail), "orig" (admin-only).
  return `${API}/files/${storagePath}?size=${size}`;
};

export const formatApiError = (err) => {
  if (err?.code === "ERR_NETWORK" || err?.message === "Network Error") {
    return "Error de conexión. Revisa tu internet y vuelve a intentarlo.";
  }
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Unknown error";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
};
